/* eslint-disable react/require-default-props */
import React from 'react';
import { Tooltip } from 'antd';

type TooltipTableProps = {
    valueCell: string | number;
    ptbrCurrency?: boolean;
};

const CellWithTooltip: React.FC<TooltipTableProps> = ({
    valueCell,
    ptbrCurrency,
}) => {
    const formatPriceToPtBrCurrency = (price: number) =>
        price.toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL',
        });

    const value = ptbrCurrency
        ? formatPriceToPtBrCurrency(Number(valueCell))
        : valueCell;

    return (
        <Tooltip placement="topLeft" title={value}>
            {value}
        </Tooltip>
    );
};

export default CellWithTooltip;
